// extracted by css-extract-rspack-plugin
export default {"tabContent":"NBq2l"};